export function generatePKCECodeVerifier() {
    const array = new Uint8Array(32);
    crypto.getRandomValues(array);
    return replaced(array);
}
export async function generatePKCECodeChallenge(codeVerifier) {
    const data = new TextEncoder().encode(codeVerifier);
    const digest = await crypto.subtle.digest("SHA-256", data);
    return replaced(new Uint8Array(digest));
}
function replaced(array) {
    return btoa(String.fromCharCode(...array))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
}
